// The URL shared everywhere (bio links, QR codes, social shares) — always points
// at production regardless of which deploy the page is actually running on.
export const SITE_URL = 'https://mukeshrathore.com';
export const LISTEN_URL = `${SITE_URL}/listen`;
export const ARTIST_NAME = 'Mukesh Rathore';
